import { bevelPositions, frameTypes } from '../config'

export default {
  APP_TYPE: 'omega',
  isAdvancePaymentSystemEnabled: true,
  isSummaryTooltipEnabled: true,
  isCanCreateOrdersForOthersEnabled: true,
  isOrderCancellationEnabled: true,
  hasLogoutInHeader: true,
  orderCancellationTime: 60,
  isBifocalVisualisationEnabled: true,
  showShapeGeometryCenterAtStep2: true,
  showFooterImpressum: false,
  showFooterGdprDoc: false,
  showFooterLegalDoc: false,
  showOrdersTableIdColumn: false,
  hideOrdersSourceSwitch: false, // hide order source switch on HP
  useNativeCookieConsent: true,
  defaultCopyReferenceOnDuplication: false,
  safetyMarginStock: 1, // value added to radius
  safetyMarginManufacturer: 1.5, // value added to radius
  isMiLensEnabled: true,
  orderSanitizeStringsVariant: 'FULL', // FULL or SOFTER
  areFtpDeliveryNotesEnabled: true,
  hostConf: {
    isGoToWowEnabled: true,
    wowUrl: '',
    htmlTitle: 'Omega Direct Web',
    logo: {
      publicPath: '/public/images/logo-omega.png?v=2',
    },
    logoSquared: {
      publicPath: '/public/images/logo-omega-squared.png?v=2',
    },
    favicon: {
      publicPath: '/public/favicon-omega.ico?v=3',
    },
    areDeliveryNotesEnabled: true,
    deliveryNotesVersion: 'default',
    isGetOrderPriceEnabled: true,
    isBulkOrderEnabled: 'byEntitlement',
  },
  uniqueTranslationKeyPrefix: 'omega;',
  versionPrefix: 'o',
  isGoToWowEnabled: true,
  isBulkOrderEnabled: true,
  isBulkOrderRemarkEnabled: true,
  isBulkOrderSideEnabled: true,
  languages: ['en', 'es', 'fr', 'de', 'cs', 'hr', 'ru', 'it', 'pt'],
  isCustomDiameterEnabled: true,
  isEllipticalDiameterEnabled: true,
  isInternalNoteEnabled: true,
  // considerDesignShift: false, // in lens diameter calculation (getFinalRadiiByShapeAndLenses) - not used anymore
  isLensBaseEnabled: true, // base curve field in refractions section
  // select base curve field after diameter selection with options from catalog
  isBaseCurveSelectEnabled: false,
  isSphAndCylInHundredthsEnabled: false,
  sphAndCylInHundredthsGroups: [],
  isWithShapeOnlyLensesEnabled: true,
  showCalcSurfacePoints: true,
  isExpressOrderEnabled: true,
  isExpress48Enabled: false,
  isCenterThicknessEnabled: true,
  step2DefaultBevelPositionForEdgingOrder: undefined,
  step2AutoPolish: true, // in step 2, automatically set polish field based on frame type
  // let user decide wether spectacles (only) lenses should be polished, customizable via group
  isSpectaclesPolishEnabled: false,
  isPinBevelEnabled: false,
  areFramesEnabled: true,
  isUvSelectionEnabled: true,
  isDecentrationEnabled: true,
  isSoapEnabled: true,
  isSortLensOptionsByNameEnabled: true,
  isMandatoryColorPreselectEnabled: true,
  soapWsdlDev: 'order-import-omega-dev', // deprecated
  soapWsdl: 'order-import-omega', // deprecated
  soapDevUrl: 'https://soap.omega.azuredev.virtii.com',
  soapProdUrl: 'https://soap.omegadirect.cz',

  isFrameCurveStep2Visible: true,

  arePromotionsEnabled: false,

  // enables fetching order prices from LW soap server
  // isGetOrderPriceEnabled: true must be added to hostConf
  isGetPricesFromLWSoapEnabled: true,

  isAccountInfoVisible: false,

  lensFocusTypes: {
    'Single vision': {
      S: 'Single vision conv',
      X: 'Single vision individual',
    },
    A: 'Multifocal',
    Progressive: {
      C: 'Progressive conv',
      F: 'Progressive freeform',
      I: 'Progressive individual',
      U: 'Progressive Duo',
    },
    D: 'Office / Degressive',
    B: 'Bifocal',
  },

  // deprecated, used as fallback
  // set it in keystone frameBrand
  suppliersMap: {
    OME: 'OME',
    '4EY': '4 Eyes',
  },

  individualMenus: {
    // omitted = hidden
    // { isRequired: true } = shown, required (boolean true still supported)
    // { isRequired: false } = shown, optional (boolean false still supported)
    // order matters! Higher wins if two different lenses selected
    FFUNUZ: {
      bvd: {
        isRequired: true,
        min: 5,
        max: 20,
      },
      panto: {
        isRequired: true,
        min: 0,
        max: 25,
      },
      frameBowAngle: {
        isRequired: true,
        min: 0,
        max: 25,
      },
      fvs: { // new
        isRequired: true,
        min: -5,
        max: 5,
      },
      nvs: { // new
        isRequired: true,
        min: -5,
        max: 5,
      },
      designType: { // new
        isRequired: true,
        min: 10,
        max: 99,
      },
      contrastSv: { // new
        isRequired: true,
        min: -5,
        max: 5,
      },

      inset: {
        isRequired: false,
        min: 0,
        max: 5,
      },
    },
    FFUIOT: {
      bvd: { isRequired: true },
      panto: { isRequired: true },
      frameBowAngle: { isRequired: true },
    },
    SPT001: {
      bvd: { isRequired: true },
      panto: { isRequired: true },
      frameBowAngle: { isRequired: true },
    },
    FFUINS: {
      bvd: { isRequired: true },
      panto: { isRequired: true },
      frameBowAngle: { isRequired: true },
    },
    FFUSP1: {
      panto: { isRequired: false },
      frameBowAngle: { isRequired: false },
    },
    FFUSP2: {
      panto: { isRequired: false },
      frameBowAngle: { isRequired: false },
    },
    FFUSLM: {},
    FFUCRB: {
      bvd: {
        isRequired: false,
        min: 6,
        max: 30,
      },
      panto: {
        isRequired: false,
        min: 0,
        max: 30,
      },
      frameBowAngle: {
        isRequired: false,
        min: 0,
        max: 35,
      },
    },
    FFUSP3: {
      bvd: { isRequired: false },
      panto: { isRequired: false },
      frameBowAngle: { isRequired: false },
    },
    FFUFFM: {
      bvd: {
        isRequired: false,
        min: 5,
        max: 20,
      },
      frameBowAngle: {
        isRequired: false,
        min: 0,
        max: 45,
      },
      panto: {
        isRequired: false,
        min: -8,
        max: 25,
      },
    },
    FFUARX: {
      bvd: {
        isRequired: false,
        min: 5,
        max: 20,
      },
      frameBowAngle: {
        isRequired: false,
        min: 0,
        max: 45,
      },
      panto: {
        isRequired: false,
        min: -8,
        max: 25,
      },
      proglen: {
        isRequired: true,
        options: [
          {
            value: 5,
            label: '14 / 0,50',
          },
          {
            value: 7,
            label: '14 / 0,75',
          },
          {
            value: 10,
            label: '14 / 1,00',
          },
          {
            value: 12,
            label: '14 / 1,25',
          },
          {
            value: 15,
            label: '16 / 0,50',
          },
          {
            value: 17,
            label: '16 / 0,75',
          },
          {
            value: 20,
            label: '16 / 1,00',
          },
          {
            value: 22,
            label: '16 / 1,25',
          },
        ],
      },
    },
    FFUPRO: {
      bvd: {
        isRequired: true,
        min: 5,
        max: 20,
      },
      frameBowAngle: {
        isRequired: true,
        min: 0,
        max: 45,
      },
      panto: {
        isRequired: true,
        min: -8,
        max: 25,
      },
      proglen: {
        isRequired: true,
        options: [
          {
            value: 12,
            label: '14',
          },
          {
            value: 13,
            label: '15',
          },
          {
            value: 14,
            label: '16',
          },
          {
            value: 15,
            label: '17',
          },
          {
            value: 16,
            label: '18',
          },
        ],
      },
    },
    FFULTE: {
      bvd: {
        isRequired: false,
        min: 5,
        max: 20,
      },
      frameBowAngle: {
        isRequired: false,
        min: 0,
        max: 45,
      },
      panto: {
        isRequired: false,
        min: -8,
        max: 25,
      },
      proglen: {
        isRequired: true,
        options: [
          {
            value: 12,
            label: '14',
          },
          {
            value: 13,
            label: '15',
          },
          {
            value: 14,
            label: '16',
          },
          {
            value: 15,
            label: '17',
          },
          {
            value: 16,
            label: '18',
          },
        ],
      },
    },
    FFUDRV: {
      bvd: {
        isRequired: false,
        min: 5,
        max: 20,
      },
      frameBowAngle: {
        isRequired: false,
        min: 0,
        max: 45,
      },
      panto: {
        isRequired: false,
        min: -8,
        max: 25,
      },
    },
    FFUSTY: {
      bvd: {
        isRequired: false,
        min: 5,
        max: 20,
      },
      frameBowAngle: {
        isRequired: false,
        min: 0,
        max: 45,
      },
      panto: {
        isRequired: false,
        min: -8,
        max: 25,
      },
      proglen: {
        isRequired: true,
        options: [
          {
            value: 12,
            label: 'Shallow',
          },
          {
            value: 14,
            label: 'Regular',
          },
          {
            value: 16,
            label: 'Deep',
          },
        ],
      },
    },
    FFUSPL: {
      bvd: {
        isRequired: false,
        min: 5,
        max: 20,
      },
      frameBowAngle: {
        isRequired: false,
        min: 0,
        max: 45,
      },
      panto: {
        isRequired: false,
        min: -8,
        max: 25,
      },
      proglen: {
        isRequired: true,
        options: [
          {
            value: 12,
            label: 'Shallow',
          },
          {
            value: 14,
            label: 'Regular',
          },
          {
            value: 16,
            label: 'Deep',
          },
        ],
      },
    },
    FFUBAT: {
      bvd: {
        isRequired: false,
        min: 5,
        max: 20,
      },
      frameBowAngle: {
        isRequired: false,
        min: 0,
        max: 45,
      },
      panto: {
        isRequired: false,
        min: -8,
        max: 25,
      },
    },
    FFUAST: {
      bvd: {
        isRequired: false,
        min: 5,
        max: 20,
      },
      frameBowAngle: {
        isRequired: false,
        min: 0,
        max: 45,
      },
      panto: {
        isRequired: false,
        min: -8,
        max: 25,
      },
      proglen: {
        isRequired: true,
        options: [
          {
            value: 1,
            label: '1.3m',
          },
          {
            value: 2,
            label: '2m',
          },
          {
            value: 4,
            label: '4m',
          },
        ],
      },
    },
    FFUADW: {
      bvd: {
        isRequired: false,
        min: 5,
        max: 20,
      },
      frameBowAngle: {
        isRequired: false,
        min: 0,
        max: 45,
      },
      panto: {
        isRequired: false,
        min: -8,
        max: 25,
      },
      proglen: {
        isRequired: true,
        options: [
          {
            value: 1,
            label: '0,75',
          },
          {
            value: 2,
            label: '1,25',
          },
        ],
      },
    },
  },

  isFrameCurveModifierDisabled: true,
  getBevelPositions: () => [
    bevelPositions.AUTO,
    bevelPositions.FRONT,
    bevelPositions.PERCENT,
    bevelPositions.HALF,
    bevelPositions.FRAMECURVE,
  ],
  // should be function returning array, otherwise default - all; check jzo for reference
  getFrameTypes: () => [
    frameTypes.METAL,
    frameTypes.PLASTIC,
    frameTypes.SPECIAL,
    frameTypes.NYLOR,
    frameTypes.DRILLED,
    frameTypes.GROOVEDDRILLED,
  ],
}
